import type { ButtonHTMLAttributes } from 'react'
import { cx } from './cx'
import styles from './Chip.module.css'

interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean
}

/** Selectable chip for units, categories and carriers. */
export function Chip({ selected = false, className, type = 'button', ...rest }: ChipProps) {
  return (
    <button
      {...rest}
      type={type}
      aria-pressed={selected}
      className={cx(styles.chip, selected && styles.selected, className)}
    />
  )
}
